/**
 * User: mphee
 * Date: 1/4/13
 * Time: 12:39 PM
 */

if (!window.console) window.console = {};
if (!window.console.log) window.console.log = function () { };

/*
 * Common Config object.
 */
var TWENTY_MINUTES = 1200;
var I18N_CACHE_KEY = 'i18n';

window.commonConfig = {
  setup: function () {
    // Create a global jQuery instance
    window.$ = window.jQuery = $;

    this._setupOeAppData();
    this._setupAjax();
    this._setupExtensions();
    this._setupNls();
    this._setupI18nShim();
    this._setupMobile();
    this._setupGoogleTagManager();
    this._postTasks();

    // todo: need method to update the head with common items like favicon and meta data.
  },

  _postTasks: function () {
    var _this = this;
    $(document).ready(function () {
      _this.replaceRecursive(
        document.getElementsByTagName('html')[0],
        window.navigator.userLanguage || window.navigator.language,
        _this.getNLS().split('-')[0].toLowerCase()
      );
    });
  },

  replaceRecursive: function (element, browserlang, appLang) {
    if (
      element &&
      element.style &&
      this.getStyle(element, 'text-transform') == 'uppercase'
    ) {
      if (element.value) {
        if (browserlang == 'tr') {
          if (browserlang == appLang) {
            element.value = element.value.replace(/&#x131;/g, 'I');
            element.value = element.value.replace(/i/g, '\u0130');
          } else {
            element.value = element.value.replace(/i/g, 'I');
          }
        }
      }
      for (var i = 0; i < element.childNodes.length; ++i) {
        if (element.childNodes[i].nodeType == Node.TEXT_NODE) {
          if (browserlang == 'tr') {
            if (browserlang == appLang) {
              element.childNodes[i].textContent = element.childNodes[
                i
              ].textContent.replace(/&#x131;/g, 'I');
              element.childNodes[i].textContent = element.childNodes[
                i
              ].textContent.replace(/i/g, '\u0130');
            } else {
              element.childNodes[i].textContent = element.childNodes[
                i
              ].textContent.replace(/i/g, 'I');
            }
          }
        } else {
          this.replaceRecursive(element.childNodes[i], browserlang, appLang);
        }
      }
    } else {
      if (!element.childNodes || element.childNodes.length == 0) return;

      for (var i = 0; i < element.childNodes.length; ++i) {
        this.replaceRecursive(element.childNodes[i], browserlang, appLang);
      }
    }
  },

  getStyle: function (element, style) {
    var result;

    if (document.defaultView && document.defaultView.getComputedStyle) {
      result = document.defaultView
        .getComputedStyle(element, '')
        .getPropertyValue(style);
    } else if (element.currentStyle) {
      style = style.replace(/\-(\w)/g, function (strMatch, p1) {
        return p1.toUpperCase();
      });
      result = element.currentStyle[style];
    }
    return result;
  },

  _setupOeAppData: function () {
    if (!window.oeApp.hasData('common')) {
      window.oeApp.addData({ common: {} });
    }

    var common = window.oeApp.getData('common');

    if (!common.oeUserAgent) {
      common.oeUserAgent = this._getCookie('oe-user-agent');
    }

    if (!common.supportedLanguages) {
      var fetchSupportedLanguages = function () {
        return $.ajax({
          url: oeApp.getData('common').courseServiceHost + '/v1/languages/supported',
          async: false,
          data: { language: oeApp.getData('person').preferredLang }
        }).then(function (response) {
          return response;
        });
      };

      fetchSupportedLanguages().then(function (supportedLanguages) {
        common.supportedLanguages = supportedLanguages;
      });
    }
  },

  _setupAjax: function () {
    $.ajaxSetup({
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      statusCode: {
        401: function () {
          window.location = window.oeApp.getData('common').loginUrl;
        },
      },
    });
  },

  /** mainly for IE **/
  _setupExtensions: function () {
    if (typeof String.prototype.trimLeft !== 'function') {
      String.prototype.trimLeft = function () {
        return this.replace(/^\s+/, '');
      };
    }
    if (typeof String.prototype.trimRight !== 'function') {
      String.prototype.trimRight = function () {
        return this.replace(/\s+$/, '');
      };
    }
    if (typeof Array.prototype.map !== 'function') {
      Array.prototype.map = function (callback, thisArg) {
        for (var i = 0, n = this.length, a = []; i < n; i++) {
          if (i in this) a[i] = callback.call(thisArg, this[i]);
        }
        return a;
      };
    }
  },

  showNlsConsole: function () {
    return this._getCookie('consoles') === 'nlsConsole';
  },

  /*
   * Setup for mobile use.
   */
  _setupMobile: function () {
    var $body = $('body');

    if (window.oeApp.isMobileDevice()) {
      $body.addClass('mobile');
    }

    if (window.oeApp.isTouchDevice()) {
      $body.addClass('touch');
    }

    if (window.oeApp.isAndroidDevice()) {
      $body.addClass('android');
    }
  },

  _setupNls: function () {
    // Setup the NLS console.
    if (this.showNlsConsole()) {
      require(['admin/views/NlsConsole'], function (NlsConsole) {
        new NlsConsole({ el: $('body') });
      });
    }

    // Add NLS value to body.
    $('body').addClass('lang-' + this.getNLSLanguage());
  },

  _setupI18nShim: function () {
    var fetchLanguageStrings = function (languageCode) {
      return $.ajax({
        url: oeApp.getData('common').oeThirdpartyServiceHost + '/v1/nls/' + languageCode + '/messages',
        async: false,
      }).then(function (response) {
        window._translations[languageCode] = _.clone(response);
        return response;
      });
    };

    window._translations = {};
    var lang = this.getNLSLanguage();

    var setI18nCache = function (lang, i18n) {
      window.localStorageCache.set(I18N_CACHE_KEY, { lang: lang, i18n: i18n }, TWENTY_MINUTES);
    };

    var i18nCached = window.localStorageCache.get(I18N_CACHE_KEY);
    var i18nCachedData = i18nCached && i18nCached.data && i18nCached.data.i18n;
    var i18nCachedLang = i18nCached && i18nCached.data && i18nCached.data.lang;
    var isCached = i18nCachedData && i18nCachedLang && i18nCachedLang === lang;
    var isExpired = i18nCached && i18nCached.expire && (i18nCached.expire <= new Date().getTime());
    
    var fetchTranslations = function () {
      fetchLanguageStrings(lang)
        .then(function (nativeJson) {
          window.i18n = _.clone(nativeJson);
          setI18nCache(lang, window.i18n);
        })
        .fail(function (error) {
          console.error('Error fetching language strings', error);
          if (isCached) {
            setI18nCache(lang, window.i18n);
          }
        });
    }

    // Scenario 1: Return cached data if exists and is not expired
    if (!isExpired && isCached) {
      console.log('Returning cached data (not expired)');
      window.i18n = i18nCachedData;
    }
    // Scenario 2: If cached data exists but is expired, return cached data initially, then fresh data
    else if (isExpired && isCached) {
      console.log('Returning cached data initially (expired), then fetching fresh data');
      window.i18n = i18nCachedData;
      fetchTranslations();
    } else {
      console.log('No cached data, fetching from server');
      fetchTranslations();
    }

    var _getTranslationFromSource = function (
      source,
      propertyNames,
      data,
      defaultValue
    ) {
      var text = _.get(source, propertyNames, defaultValue);
      if (data) {
        // supports normal es6 ${variable} interpolation
        text = _.template(text)(data);
      }

      return text || propertyNames;
    };

    var _getTranslation = function (
      propertyNames,
      data,
      defaultValue,
      languageCode
    ) {
      if (languageCode) {
        if (!window._translations[languageCode]) {
          fetchLanguageStrings(languageCode);
        }

        return _getTranslationFromSource(
          window._translations[languageCode],
          propertyNames,
          data,
          defaultValue
        );
      }

      return _getTranslationFromSource(
        window.i18n,
        propertyNames,
        data,
        defaultValue
      );
    };

    window.i18n.get = function (
      propertyNames,
      data,
      defaultValue,
      languageCode
    ) {
      return _getTranslation(propertyNames, data, defaultValue, languageCode);
    };

    window.i18n.getDefault = function (propertyNames, defaultValue, data) {
      return _getTranslation(propertyNames, data, defaultValue);
    };
  },

  _getCookie: function (name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  _setCookie: function (name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  },

  getNLS: function () {
    var locale = window.oeApp.getData('locale');
    return this._getCookie('NLS') || locale || 'en';
  },

  getLiveAgentNLS: function () {
    var nls = this._getCookie('NLS');
    if (!nls || nls == 'en') {
      return 'es';
    }
    return nls;
  },

  // Return just the language portion of the NLS value (i.e. don't include the country specific portion).
  getNLSLanguage: function () {
    var nls = this.getNLS().split('-')[0].toLowerCase();
    if (!this.isSupportedLanguage(nls)) {
      return 'en';
    }

    return nls;
  },

  setNLS: function (newNLS) {
    if (newNLS) newNLS = newNLS.toLowerCase();
    this._setCookie('NLS', newNLS, 30);
    return true;
  },

  getParameterByName: function (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regexS = '[\\?&]' + name + '=([^&#]*)';
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.search);
    if (results == null) {
      return '';
    }
    return decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  playDictAudio: function (count) {
    var audio = document.getElementsByTagName('audio')[count];
    audio.load();
    audio.play();
  },

  _setupGoogleTagManager: function () {
    window.oeApp.setupGoogleTagManager();
  },

  isSupportedLanguage: function (nls) {
    var supported = window.oeApp.supportedLanguagesCode();
    if (supported) {
      return nls.match(supported.join('|')) != null;
    }

    return nls.match('en|es|pt|tr') != null;
  },
};

if ('1' === commonConfig.getParameterByName('nlsConsole')) {
  commonConfig._setCookie('consoles', 'nlsConsole');
} else if ('0' === commonConfig.getParameterByName('nlsConsole')) {
  commonConfig._setCookie('consoles', '');
}

window.oeApp = {
  data: {},
  clientStartTime: new Date(),
  nlsData: [],

  addData: function (data) {
    $.extend(this.data, data);
  },

  addNlsData: function (data) {
    var index = this.nlsData.length;

    this.nlsData[index] = data;

    return index;
  },

  getData: function (key) {
    return typeof this.data[key] !== 'undefined' ? this.data[key] : {};
  },

  getCurrentTime: function () {
    if (this.hasData('common')) {
      var commonData = this.getData('common'),
        currentClientTime = new Date().getTime();

      return commonData.serverTime + currentClientTime - this.clientStartTime;
    } else if (this.hasData('serverTime')) {
      var serverTime = this.getData('serverTime'),
        currentClientTime = new Date().getTime();

      return serverTime + currentClientTime - this.clientStartTime;
    } else {
      return null;
    }
  },

  getNlsData: function (index) {
    if (index != null) {
      return this.nlsData[index];
    } else {
      return {};
    }
  },

  getServerTimezone: function () {
    if (this.hasData('common') && this.getData('common').uiTimezone) {
      return window.oeApp.getData('common').uiTimezone;
    } else {
      return 'America/New_York';
    }
  },

  getTimezone: function () {
    if (this.hasData('person') && this.getData('person').timezone) {
      return this.getData('person').timezone;
    } else {
      return this.getServerTimezone();
    }
  },

  hasData: function (key) {
    return this.data[key] ? true : false;
  },

  isAndroidDevice: function () {
    var ua = navigator.userAgent.toLowerCase(),
      isAndroid = ua.indexOf('android') > -1;

    return isAndroid;
  },

  isIphone: function () {
    const agent = navigator.userAgent.toLowerCase();
    const isIphone = agent.indexOf('iphone') > -1;

    return isIphone;
  },

  isIpad: function () {
    const agent = navigator.userAgent.toLowerCase();
    const isIpadOld = agent.indexOf('ipad') > -1;
    const isIpadOS =
      /mac os/.test(agent) &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 1;

    return isIpadOld || isIpadOS;
  },

  isIosDevice: function () {
    return this.isIphone() || this.isIpad();
  },

  isLoggedIn: function () {
    return this.hasData('person');
  },

  isMobileDevice: function () {
    return this.isAndroidDevice() || this.isIosDevice();
  },

  isNotMobileDevice: function () {
    return !this.isMobileDevice();
  },

  isNotProduction: function () {
    return !this.isProduction();
  },

  isOpenEnglishDevice: function () {
    var oeUserAgent = this.getData('common').oeUserAgent
      ? this.getData('common').oeUserAgent
      : '';

    return oeUserAgent.indexOf('LP2') == 0;
  },

  isProduction: function () {
    return 'PRD' === this.getData('common').env;
  },

  isTouchDevice: function () {
    return this.isAndroidDevice() || this.isIosDevice();
  },

  supportedLanguages: function () {
    return this.getData('common').supportedLanguages;
  },

  supportedLanguagesCode: function () {
    return this.getData('common').supportedLanguages
      .map(function (lang) {
        return lang.code;
      });
  },

  setupGoogleTagManager: function () {
    if (this.hasData('common') && this.getData('common').googleTagManagerId) {
      var googleTagManagerId = this.getData('common').googleTagManagerId;
      var GoogleTagManager = require('common/scripts/GoogleTagManager');
      jQuery('body').prepend(GoogleTagManager.getScript(googleTagManagerId));
    }
  },
};

window.localStorageCache = {
  get: function (key) {
    var cached = localStorage.getItem(key);
    if (cached) {
      return JSON.parse(cached);
    }
    return null;
  },

  set: function (key, data, seconds) {
    if (!key || !data || !seconds) {
      return null;
    }

    var item = {
      data: data,
      expire: expirationTime(seconds),
    };

    localStorage.setItem(key, JSON.stringify(item));

    function expirationTime(seconds) {
      var date = new Date();
      date.setSeconds(date.getSeconds() + seconds);
      return date.getTime();
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./js/common/CommonConfig.js
// module id = 1824
// module chunks = 4